<template v-if="package">
  <a :id="id"></a>
</template>

<script>
export default {
  props: ['package', 'size', 'color'],
  data () {
    return {
      id: -1,
      mutableSize: this.size || 'small',
      mutableColor: this.color || 'silver'
    }
  },
  computed: {
    currentUser () {
      return this.$store.state.currentUser
    },
    packageId () {
      return this.package.id
    }
  },
  mounted () {
    this.id = `p${this._uid}`
    var that = this
    this.$nextTick(() => {
      paypal.Button.render({
        env: `${PAYPAL_MODE}`, // Specify 'sandbox' for the test environment
        style: {
          size: this.mutableSize,
          shape: 'rect',
          color: this.mutableColor
        },
        commit: true,
        payment: function (resolve, reject) {
          const CREATE_PAYMENT_URL = `${BASE_URL}/payment`
          paypal.request.post(CREATE_PAYMENT_URL, {id: that.packageId, userID: that.currentUser.id})
              .then(function (data) {
                resolve(data.paymentID)
              })
              .catch(function (err) { reject(err) })
        },
        onAuthorize: function (data, actions) {
          const EXECUTE_PAYMENT_URL = `${BASE_URL}/payment/execute`
          paypal.request.post(EXECUTE_PAYMENT_URL,
                  { paymentID: data.paymentID, payerID: data.payerID, userID: that.currentUser.id, packageID: that.packageId })
              .then(function (data) {
                that.$router.push('/picks')
              })
              .catch(function (err) { console.log(err) })
        }
      }, `#${this.id}`)
    })
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// paypalButton.vue?76579e6d